/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';

import {
  IcecontrolSettings,
  iceColumnDefinition,
} from 'projects/icemedx-lib/src/components/models/icesettings';

import { IIceEntity } from 'projects/icemedx-lib/src/models/core/IceEntity';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';

import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { PatientService } from 'projects/icemedx-lib/src/services/patient/patient.service';
import { ScheduleService } from 'projects/icemedx-lib/src/services/schedule/schedule.service';

import { PhrBaseListView } from '../phrbaselistview.component';
import { MedicalcodesService } from 'projects/icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { userTypes } from 'projects/icemedx-lib/src/login/login.config';
import { MessageService } from 'projects/icemedx-lib/src/services/message/message.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { appointment } from '../../../../icemedx-lib/src/models/schedule/appointment';

@Component({
  selector: 'app-phrappointments',
  templateUrl: './phrappointments.component.html',
  styleUrls: ['./phrappointments.component.scss'],
  providers: [AppService, IceNavService]
})
export class PhrappointmentsComponent extends PhrBaseListView implements OnInit {
  private types = [];

  constructor(appSvc: AppService, private domainSvc: DomainService, loginSvc: LoginService, private codeSvc: MedicalcodesService, messageSvc: MessageService, navSvc: IceNavService, ptSvc: PatientService, private proService: ProviderService, private schService: ScheduleService, router: Router) {
    super(appSvc, loginSvc, navSvc, ptSvc, router);

    let feaAccess = this.getPermission(userTypes.USER_FEATURES.ufSchedule).default_access;
    this.nameOfView = "Appointments";
    appSvc.defaultMenus();
    appSvc.addBreadcrumb(this.nameOfView, {}, true, "");

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      setTimeout(function () {
        messageSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
    } else {
      this.setInlineEditing(true);
      this.dataViewSettings = this.viewSetup([], userTypes.USER_FEATURES.ufSchedule);

      ptSvc.getAllAppointments(appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient ? appSvc.getCurrentAccount() : appSvc.getCurrentPatient(), "", IceTypes.ACCOUNT_TYPE.actNone, "", "", "", "").subscribe(
        data => {
          this.refreshTableData(data);
        },
        error => {
        });
    }

    this.codeSvc.getCodes("SUBTYPE_ITEM", "", IceTypes.SourceType.srcTypeOfService.toString(), "", "", IceTypes.ACCOUNT_TYPE.actProvider).subscribe(
      data => {
        if (data != null) {
          this.types = data;
        }
      });
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    return [
      new iceColumnDefinition("telehealth_class", "", false, false,
        new IcecontrolSettings("icebutton", { class: "fas fa-video", width: "50px", tooltip: "Join" }, null, null)),
      new iceColumnDefinition("start", "Start Time", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("appointment_status", "Status", false, false,
        new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
      new iceColumnDefinition("appointment_type", "Type", false, false,
        new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
      new iceColumnDefinition("providers", "Provider(s)", false, false,
        new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
      new iceColumnDefinition("appointment_key", "appointment_key", true),
    ];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    let displayApts = [];
      let duplicateApts = {};
    for (let iapt = 0; iapt < originalData.length; iapt++) {
      let providers = originalData[iapt]["provider_keywords"].split(",");
      originalData[iapt]["providers"] = "";

      /// TODO: refactor this code
      if (duplicateApts[originalData[iapt]["appointment_key"]] != null) {
        for (var iprov = 0; iprov < providers.length; iprov++) {
          var provider = providers[iprov].trim();
          if (provider != "") {
            let cachedProvider = DomainService.mappedProviders[provider.toLowerCase()];

            if (cachedProvider) {
              setTimeout(function () {
                if (displayApts[iapt].providers.indexOf(cachedProvider) === -1) {
                  displayApts[iapt].providers += ", " + cachedProvider;
                }
              }, 200);
            } else {
              this.domainSvc.getProviderName(provider)
                .subscribe(data => {
                  if (data && data.length > 0) {
                    if (this.tables[0].iRows.data[iapt]) {
                      if (displayApts[iapt]) {
                        displayApts[iapt].providers += (displayApts[iapt].providers ? ", " : "") + data[0]._providerName;
                      }
                    }
                  }
                });
            }
          }
        }
        continue;
      }

      let dt = Iceutility.ConvertFromDotNetServerTime(originalData[iapt]["time_slot_start"]);
      let index = Iceutility.searchArrayByField(this.types, "sub_type", originalData[iapt]["appointment_type"]);

      for (var iprov = 0; iprov < providers.length; iprov++) {
        var provider = providers[iprov].trim();
        if (provider != "") {
          let cachedProvider = DomainService.mappedProviders[provider.toLowerCase()];

          if (cachedProvider) {
            originalData[iapt]["providers"] += (originalData[iapt]["providers"] ? ", " : "") + cachedProvider;
          } else {
            this.domainSvc.getProviderName(provider)
              .subscribe(data => {
                if (data && data.length > 0) {
                  if (this.tables[0].iRows.data[iapt]) {
                    if (displayApts[iapt]) {
                      displayApts[iapt].providers += (displayApts[iapt].providers ? ", " : "") + data[0]._providerName;
                    }
                  }
                }
              });
          }
        }
      }

      let iconToUse = "fas fa-walking";
      if (Iceutility.toBoolean(originalData[iapt]["telehealth"])) {
        iconToUse = "fas fa-video";
      }

      if (this.schService.appointmentInSession(originalData[iapt]["time_slot_start"], originalData[iapt]["time_slot_end"], originalData[iapt]["appointment_status"]))
        iconToUse += " " + "alert-success";
      else
        iconToUse = ""; 

      let dApt = {
        start: Iceutility.getDateTextEx(dt),
        appointment_status: ScheduleService.getApptStat(originalData[iapt]["appointment_status"]),
        appointment_type: (index >= 0 ? this.types[index]["title"] : ""),
        providers: originalData[iapt]["providers"],
        appointment_key: originalData[iapt]["appointment_key"],
        account_type: originalData[iapt]["account_type"],
        trans_account: originalData[iapt]["trans_account"],
        time_slot_start: originalData[iapt]["time_slot_start"],
        time_slot_end: originalData[iapt]["time_slot_end"],
        telehealth: originalData[iapt]["telehealth"],
        telehealth_class: iconToUse,
      };
      displayApts.push(dApt);
      duplicateApts[originalData[iapt]["appointment_key"]] = dApt;
    }
    return displayApts;
  }

  onMattableColClick(event) {
    if (event.rowData == null) return;
    if (event.colDef == null) return;
    if (Iceutility.isdefined(event.rowData["appointment_key"]) == false) return;
    if (Iceutility.isdefined(event.rowData["telehealth"]) == false) return;
    let apptkey = event.rowData["appointment_key"];
    let telehealth = event.rowData["telehealth"];
    if (Iceutility.toBoolean(telehealth)) {
      this.proService.getAppointment(event.rowData.trans_account, event.rowData.account_type, apptkey).subscribe(
        data => {
          if (data == null || data.length == 0) return;
          let appt: appointment = <appointment>data[0];
          if (this.schService.appointmentInSession(appt.time_slot_start, appt.time_slot_end, appt.appointment_status))
            this.schService.navigateToTelehealth(appt.telehealth_url);
        },
        error => {
        });
    }
  }
}
